export default "https://assets.egbcdn.net/assets/packs/_/sounds/poker/first-b0491f6f457134627379477f6d316928.mp3";